import { Component, OnInit } from '@angular/core';
import {UserService} from "../../services/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {User} from "../../models/user";

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: [
    './reset.component.css',
    '../login/css/style.css',
    '../login/font-awesome/css/font-awesome.min.css',
    '../login/perfect-scrollbar/dist/css/perfect-scrollbar.min.css'
  ],
  providers: [UserService]
})

export class ResetComponent implements OnInit {
  public user : User;
  public message;
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService
  ) {
    this.user = new User(1,  '',  '',  '',  '',  '',  '', 0, 0);
  }

  ngOnInit(){
  }

  onSubmit(){
    this._userService.httpPost('resetPassword', this.user).subscribe(
      response =>{
        //devuelve token
        this.message = response;
        console.log(this.message.message)

      },
      error =>{
        console.log(<any>error);
      }
    );

  }

}





